export default "__VITE_ASSET__CKFJ1Jhk__"